import {v4 as uuidv4} from "uuid";
import {logInfo} from "../../components/model/utils";

export async function testDataCache() {
    validateConfiguration()
    let cacheKey = "TESTONEDAY"
    let objKey = "MYOBJ"
    deleteCache(cacheKey)
    let obj = getObjectFromCache(cacheKey,objKey)
    if (obj !== undefined)
        throw Error("Should be undefined! (1)")
    saveObjectToCache(cacheKey,objKey,{message:"Hello!"})
    obj = getObjectFromCache(cacheKey,objKey)
    if (obj === undefined)
        throw Error("Should not be undefined! (2)")
    if (obj.message !== "Hello!")
        throw Error("Expected Hello!, but was:" + obj.message)
    deleteCache(cacheKey)
    obj = getObjectFromCache(cacheKey,objKey)
    if (obj !== undefined)
        throw Error("Should be undefined! (3)")
    saveObjectToCache(cacheKey,objKey,{message:"Hello!"})
    timeTravel(cacheKey, +1000)  //ms
    obj = getObjectFromCache(cacheKey,objKey)
    if (obj === undefined)
        throw Error("Should not be undefined! (4)")
    timeTravel(cacheKey, 24*3600*1000 + 1)  //Expired
    obj = getObjectFromCache(cacheKey,objKey)
    if (obj !== undefined)
        throw Error("Should be undefined! (5)")
    timeTravel(cacheKey, 0)  //Expired
}
export function saveObjectToCache(cacheKey, objKey, obj) {
    let cache = getCache(cacheKey)
    if (cache === undefined)
    {
        cache = {
            id:uuidv4(),
            creationTime: new Date().getTime()
        }
        if (!window.location.host.includes("localhost")) {
            logInfo("Cache " + cacheKey + " for object " + objKey + " created:" + cache.creationTime)
        }
    }
    cache[objKey] = obj
    saveCache(cacheKey, cache)
}
export function getObjectFromCache(cacheKey, objKey) {
    let cache = getCache(cacheKey)
    if (cache === undefined) {
        return undefined
    }
    return cache[objKey]
}
export function deleteCache(cacheKey)
{
    window.localStorage.setItem("CACHE"+cacheKey,JSON.stringify({}))
}

//-------------Implementations----


const configs = {
    TESTONEDAY:{
        expiration:24*3600*1000,
        timeTravel:0
    },
    ONEDAY:{
        expiration:24*3600*1000,
        timeTravel:0
    },
    NEVEREXPIRED:{
        expiration:24*3600*1000*365*10,
        timeTravel:0
    },
    NEVEREXPIREDCOUNTER:{
        expiration:24*3600*1000*365*10,
        timeTravel:0
    }
}
function timeTravel(cacheKey, ms) {
    let conf = getConfig(cacheKey)
    conf.timeTravel = ms
}

function saveCache(cacheKey, cache) {
    window.localStorage.setItem("CACHE"+cacheKey, JSON.stringify(cache))
}
function getCache(cacheKey) {
    let config = getConfig(cacheKey)
    let text = window.localStorage.getItem("CACHE"+cacheKey)
    if (text === undefined || text === null || text == "{}") return undefined
    let cache = JSON.parse(text)
    if (cache.creationTime === undefined) {
        return undefined
    }
    let elapsedTime = new Date().getTime() + config.timeTravel - cache.creationTime
    if (elapsedTime > config.expiration)
    {
        return undefined
    }

    return cache
}
function getConfig(cacheKey) {
    let ret = configs[cacheKey]
    if (ret === undefined)
        throw Error("Invalid cacheKey:" + cacheKey)
    return ret;
}

function validateConfiguration() {
    Object.keys(configs).forEach((configKey) =>{
        let config = configs[configKey]
        if (config.expiration === undefined)
            throw Error("Missed expiration for:" + configKey)
    })
}
